import React from "react";

interface SpinnerProps {
  text?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ text = "Loading data..." }) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center py-16 gap-3">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-orange-500 border-t-transparent" />
      <span className="text-gray-500 text-sm font-semibold">{text}</span>
    </div>
  );
};
